<template>
    <section>
        <div class="filter search_only">
            <div class="field_left">
                <p class="field">
                    <label for="vyhledavani" v-translate>Vyhledávání</label>
                    <input class="search clearable" id="vyhledavani" name="vyhledavani" size="30" v-model="searchText" type="text">
                    <a @click="clearFilter" id="vyhledavani_delete" class="clearable_btn" :title="$gettext('Vymazat text')" :style="{display: (this.searchText ? 'inline' : 'none')}" v-translate>Vymazat</a>
                </p>
            </div>
        </div>
        <div class="table_overflow">
          <table class="vypis">
            <thead>
                <tr v-if="this.filteredPurchasedVodVideos.length > 0">
                    <th class="no_padding drag_drop"></th>
                    <th class="no_padding checkbox"></th>
                    <th><span class="name"><strong v-translate>Název</strong></span></th>
                    <th><span v-translate>Cena</span></th>
                    <th><span v-translate>Zařízení</span></th>
                    <th><span v-translate>Profil</span></th>
                    <th><span v-translate>Čas zakoupení</span></th>
                    <th class="no_padding edit"></th>
                </tr>
            </thead>
            <tbody>
                <PurchasedVodVideosRow v-for="purchasedVodVideo in this.filteredPurchasedVodVideos"
                        :entity="purchasedVodVideo"
                        :vod-detail-allowed="vodDetailAllowed"
                        :key="purchasedVodVideo.id"
                        ref="purchasedVodVideo_row"
                        :selectedEntities="selectedEntities"
                        @input="select"/>
                <tr v-if="this.filteredPurchasedVodVideos.length === 0">
                    <td colspan="7" v-translate>Nebylo nalezeno žádné zakoupené TVOD video.</td>
                </tr>
            </tbody>
        </table>
        </div>
      <local-list-action-line
          :entities="filteredPurchasedVodVideos"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          @select-all="toggleSelectAll"
          @run-multiple-action="runMultipleAction"
      ></local-list-action-line>
    </section>
</template>

<script>
	import PurchasedVodVideosRow from "./PurchasedVodVideosRow.vue";
  import localTable from "@/components/mixins/local-table"

  export default {
		name: "PurchasedVodVideos",
    components: {PurchasedVodVideosRow},
    mixins: [localTable],
    props: {
      purchasedVodVideos: Array,
		},
    data () {
        return {
            searchText: ""
        }
    },
    methods: {
        clearFilter() {
            this.searchText = "";
        },
    },
    computed: {
      vodDetailAllowed(){
        return this.$_loggedUser_action_allowed('vod', 'read');
      },
      entities() {
        return Object.values(this.filteredPurchasedVodVideos);
      },
      csvHeaders() {
        return {
          'name': {name: this.$gettext('Název')},
          'price': {name: this.$gettext('Cena')},
          'device_name': {name: this.$gettext('Zařízení')},
          'subscriber_profile_name': {name: this.$gettext('Profil')},
          'purchase_timestamp': {
            name: this.$gettext('Datum zakoupení'), callback: (entity) => {
              return entity.purchase_timestamp ? this.$_datetime_format(entity.purchase_timestamp) : ''
            }
          },
        }
      },
      filteredPurchasedVodVideos() {
        if (!this.searchText) {
          return this.purchasedVodVideos;
        }

        let searchText = this.searchText.toLowerCase();

        return this.purchasedVodVideos.filter((purchasedVodVideo) => {
          return purchasedVodVideo.name.toLowerCase().includes(searchText)
              || purchasedVodVideo.id.toString().includes(searchText);
        });
      }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/purchasedVodVideos/PurchasedVodVideos.vue